import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { TermLength } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-length-verification',
  templateUrl: 'pap-length-verification.component.html',
  styleUrls: ['./pap-length-verification.component.less', '../../../shared/common.less'],
})

export class PapLengthVerificationComponent implements OnInit {
  @Input() termLength: TermLength;
  @Input() isExpanded: boolean = false;
  @Output() termLengthChange = new EventEmitter<TermLength>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  isValidated: boolean = false;

  constructor(
  ) {}
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }
  
  validateYears() {

    if (this.termLength.duration[0] < 0) {
      this.termLength.duration[0] = 0;
    } else if (this.termLength.duration[0] > 4) {
      this.termLength.duration[0] = 4;
    }
    
    if (this.termLength.duration[0] == 4) {
      this.termLength.duration[1] = 0;
    }
    
    this.onLengthChange();
  }

  validateMonths() {
    if  (this.termLength.duration[0] == 4) {
      setTimeout(() => {
        this.termLength.duration[1] = 0;
        this.onLengthChange();
      });
      return;
    } else if (this.termLength.duration[1] < 0) {
      this.termLength.duration[1] = 0;
    } else if (this.termLength.duration[1] > 11) {
      this.termLength.duration[1] = 11;
    }
    
    this.onLengthChange();
  }

  onLengthChange() {
    this.termLengthChange.emit(this.termLength);
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
